import { colors } from './semantic-color-tokens';

export const dashedBlue2 = `2px dashed ${colors.blue400}`;
export const dashedGrey1 = `1px dashed ${colors.grey300}`;
export const dashedGrey2 = `2px dashed ${colors.grey300}`;
export const solidGrey1 = `1px solid ${colors.grey300}`;
export const solidLightGrey1 = `1px solid ${colors.grey200}`;
export const solid2 = '2px solid';

export const lines = {
  /** @color Grey 90 */
  solidLightGrey1,
  /** @color Grey 80 */
  solidGrey1,
  /** @color Grey 80 */
  dashedGrey1,
  /** @color Grey 80 */
  dashedGrey2,
  /** @color Blue 60 */
  dashedBlue2,
  solid2,
};
